import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { contentEqualsaf55p28mnw74 as contentEquals } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var JsonNamesClass;
function JsonNames() {
  if (JsonNamesClass === VOID) {
    class $ {
      constructor(names) {
        this.w29_1 = names;
      }
      equals(other) {
        if (!(other instanceof JsonNames()))
          return false;
        var tmp0_other_with_cast = other instanceof JsonNames() ? other : THROW_CCE();
        if (!contentEquals(this.w29_1, tmp0_other_with_cast.w29_1))
          return false;
        return true;
      }
      hashCode() {
        return imul(getStringHashCode('names'), 127) ^ hashCode(this.w29_1);
      }
      toString() {
        return '@kotlinx.serialization.json.JsonNames(' + 'names=' + toString(this.w29_1) + ')';
      }
    }
    initMetadataForClass($, 'JsonNames');
    JsonNamesClass = $;
  }
  return JsonNamesClass;
}
var JsonClassDiscriminatorClass;
function JsonClassDiscriminator() {
  if (JsonClassDiscriminatorClass === VOID) {
    class $ {}
    initMetadataForClass($, 'JsonClassDiscriminator');
    JsonClassDiscriminatorClass = $;
  }
  return JsonClassDiscriminatorClass;
}
var JsonIgnoreUnknownKeysClass;
function JsonIgnoreUnknownKeys() {
  if (JsonIgnoreUnknownKeysClass === VOID) {
    class $ {}
    initMetadataForClass($, 'JsonIgnoreUnknownKeys');
    JsonIgnoreUnknownKeysClass = $;
  }
  return JsonIgnoreUnknownKeysClass;
}
//region block: exports
export {
  JsonClassDiscriminator as JsonClassDiscriminator3irfencugy52m,
  JsonIgnoreUnknownKeys as JsonIgnoreUnknownKeys124eml6s7t6h6,
  JsonNames as JsonNames3i9ju5gyx18ko,
};
//endregion

//# sourceMappingURL=JsonAnnotations.mjs.map
